import React from 'react';

import { setClassNames } from '../../helpers';

import classes from './Alert.module.scss';

import Icon from '../Icon/Icon';

const alert = props => {
  let icon;
  switch (props.type) {
    case 'Warning':
      icon = 'exclamation-circle';
      break;
    case 'Failure':
      icon = 'times-circle';
      break;
    default:
      icon = 'info-circle';
  }

  return (
    <div className={setClassNames(classes.Root, classes[props.type])}>
      <div className={classes.Icon}>
        <Icon icon={icon} />
      </div>
      <div className={classes.Content}>{props.children}</div>
    </div>
  );
};

export default alert;
